// Runtime env injected via /config.js (k8s ConfigMap) takes precedence over build-time env vars
const runtimeEnv = window.__ENV__ || {};

const API_BASE = runtimeEnv.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5002';
const AUTH0_AUDIENCE = runtimeEnv.REACT_APP_AUTH0_AUDIENCE || process.env.REACT_APP_AUTH0_AUDIENCE || API_BASE;

// Configuration parameters for the application
const config = {
  apiUrl: API_BASE,
  auth0Audience: AUTH0_AUDIENCE,
  googleMapsApiKey: runtimeEnv.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};

const API_URL = `${API_BASE}/api`;

// Auth configuration
const USE_MOCK_AUTH = false;

export default config;
export { API_URL, USE_MOCK_AUTH, AUTH0_AUDIENCE };
